import { styled } from "@mui/material/styles";

export const BreadcrumbContainer = styled("div")(({ theme }) => ({
    margin: `0 0 ${theme.spacing(1)} 0`,
    "& .MuiBreadcrumbs-li": {
        color: theme.palette.primary.main,
        fontSize: 14,
        lineHeight: "20px",
    },
    "& .MuiSkeleton-root": {
        height: "20px !important",
    },
}));
